import { Input, Popover } from 'element-ui';

export default {
    name: 'DisabledValue',
    props: {
        value: [Number, String],
    },
    components: {
        [Input.name]: Input,
        [Popover.name]: Popover,
    },
    computed: {
    },
    data() {
        return {
        };
    },
    methods: {
    }
};



// WEBPACK FOOTER //
// ./src/components/shared/answer-types/disabled-value/disabled-value.js